import { Fieldset } from '@calendly/form/parts'
import { I18n } from '@calendly/i18n'
import { RadioField } from '@calendly/ui/form/radio-field'
import { useState } from 'react'


import {
  DEFAULT_TIME,
  DEFAULT_UNITS,
  BOOKING_WHEN_INVITEE_BOOKED,
  BOOKING_WHEN_INVITEE_NO_SHOW,
  BOOKING_BEFORE_MEETING_STARTED,
  BOOKING_WHEN_MEETING_SCHEDULED,
  BOOKING_WHEN_MEETING_CANCELED,
  BOOKING_WHEN_MEETING_FINISHED,
  BOOKING_WHEN_MEETING_STARTED,
  BOOKING_WHEN_MEETING_RESCHEDULED
} from './consts'
import {
  TimingOptionsBlock,
  WhenBlock,
  WhenRow
} from './styles'
import { TimingInput } from './timing_input'
import { howLongText } from '../../../i18n'
import { SubTitle } from '../../../styles'


const BeforeTiming = (props) => (<TimingInput notZero {...props} />)

const WhenTiming = ({ value, units, immediatelyLabel, onChange, onError }) => {
  const immediate = (value === 0 || value === null)

  const [localValue, setValue] = useState(immediate ? DEFAULT_TIME : value)
  const [localUnits, setUnits] = useState(immediate ? DEFAULT_UNITS : units)

  const onTimingChange = (newValue, newUnits) => {
    setValue(newValue)
    setUnits(newUnits)
    onChange(newValue, newUnits)
  }

  return (
    <WhenBlock>
      <WhenRow>
        <RadioField
          checked={immediate}
          onChange={() => { onChange(0) }}
          label={immediatelyLabel}
        />
      </WhenRow>
      <WhenRow>
        <RadioField
          checked={!immediate}
          onChange={() => { onChange(localValue, localUnits) }}
          aria-label={`${localValue} ${I18n.t(`publisher.workflows.forms.trigger.units.${localUnits}`)}`}
        />
        <TimingInput
          value={localValue}
          units={localUnits}
          onChange={onTimingChange}
          onError={onError}
        />
      </WhenRow>
    </WhenBlock>
  )
}

const BookingWhenInviteeBooked = (props) => (
  <WhenTiming
    immediatelyLabel={I18n.t('publisher.workflows.triggers.booking.when.invitee_booked.immediately')}
    {...props}
  />
)

const BookingWhenMeetingScheduled = (props) => (
  <WhenTiming
    immediatelyLabel={I18n.t('publisher.workflows.triggers.booking.when.invitee_booked.immediately')}
    {...props}
  />
)

const BookingWhenMeetingStarted = (props) => (
  <WhenTiming
    immediatelyLabel={I18n.t('publisher.workflows.triggers.booking.when.meeting_started.immediately')}
    {...props}
  />
)

const BookingWhenMeetingFinished = (props) => (
  <WhenTiming
    immediatelyLabel={I18n.t('publisher.workflows.triggers.booking.when.meeting_finished.immediately')}
    {...props}
  />
)

const BookingWhenMeetingCanceled = (props) => (
  <WhenTiming
    immediatelyLabel={I18n.t('publisher.workflows.triggers.booking.when.meeting_canceled.immediately')}
    {...props}
  />
)

const BookingWhenMeetingRescheduled = (props) => (
  <WhenTiming
    immediatelyLabel={I18n.t('publisher.workflows.triggers.booking.when.meeting_rescheduled.immediately')}
    {...props}
  />
)

const BookingWhenInviteeNoShow = (props) => (
  <WhenTiming
    immediatelyLabel={I18n.t('publisher.workflows.triggers.booking.when.invitee_no_show.immediately')}
    {...props}
  />
)

const timingTypes = {
  [BOOKING_WHEN_INVITEE_BOOKED]: BookingWhenInviteeBooked,
  [BOOKING_WHEN_INVITEE_NO_SHOW]: BookingWhenInviteeNoShow,
  [BOOKING_BEFORE_MEETING_STARTED]: BeforeTiming,
  [BOOKING_WHEN_MEETING_SCHEDULED]: BookingWhenMeetingScheduled,
  [BOOKING_WHEN_MEETING_STARTED]: BookingWhenMeetingStarted,
  [BOOKING_WHEN_MEETING_FINISHED]: BookingWhenMeetingFinished,
  [BOOKING_WHEN_MEETING_CANCELED]: BookingWhenMeetingCanceled,
  [BOOKING_WHEN_MEETING_RESCHEDULED]: BookingWhenMeetingRescheduled
}

const TimingOptions = ({ triggerType, ...props }) => {
  if (!triggerType) { return null }

  const Component = timingTypes[triggerType]

  return <Component {...props} />
}

export const Timing = (props) => {
  const { triggerType } = props

  if (!triggerType) {
    return null
  }

  return (
    <Fieldset>
      <SubTitle as="legend">{howLongText(triggerType)}</SubTitle>
      <TimingOptionsBlock>
        <TimingOptions {...props} />
      </TimingOptionsBlock>
    </Fieldset>
  )
}
